import { default as minify } from "minify-fast";
import { t } from "@/i18n-js/instance";
import type { useToast } from "@circle-react-uikit/ToastV2";

interface CopyEmbedCodeProps {
  embedCodeRef: React.RefObject<HTMLDivElement>;
  embedCodeText: string;
  toast: ReturnType<typeof useToast>;
}

export const copyEmbedCode = async ({
  embedCodeRef,
  embedCodeText,
  toast,
}: CopyEmbedCodeProps) => {
  if (!embedCodeRef.current) return;

  window.getSelection()?.selectAllChildren(embedCodeRef.current);

  try {
    await navigator.clipboard.writeText(embedCodeText);
    toast.success(t("settings.forms.edit.embed.copy_success"));
  } catch {
    toast.error(t("settings.forms.edit.embed.copy_error"));
  }
};

interface EmbedCodeProps {
  currentCommunityFullUrl: string;
  formUid: string;
  isPopup: boolean;
  isPreview?: boolean;
  isUsedOnPages?: boolean;
  popupDelay?: string;
  popupFrequency?: string;
}
export const embedCode = function ({
  formUid,
  isPopup,
  currentCommunityFullUrl,
  isPreview = false,
  isUsedOnPages = false,
  popupDelay,
  popupFrequency,
}: EmbedCodeProps) {
  const code = `
    if (!window.circleFormsScriptLoaded) {
      window.circleFormsScriptLoaded = true;
      const script = document.createElement('script');
      script.src = '${currentCommunityFullUrl}external/form-embeds.js';
      script.defer = true;
      document.head.appendChild(script);
    }
  `;
  return `<div data-is-popup="${isPopup}" data-circle-form-uid="${formUid}" ${extraParams(isPreview, isUsedOnPages, isPopup, popupDelay, popupFrequency)}>
          <script>${minify({ code })}</script>`;
};

const extraParams = (
  isPreview: boolean,
  isUsedOnPages: boolean,
  isPopup: boolean,
  popupDelay?: string,
  popupFrequency?: string,
) => {
  let params = "";

  if (isPreview) {
    params += `data-is-preview="${isPreview}"`;
  }
  if (isUsedOnPages) {
    params += ` data-is-used-on-pages="${isUsedOnPages}"`;
  }
  if (isPopup) {
    params += ` data-popup-frequency="${popupFrequency}" data-popup-delay="${popupDelay}"`;
  }
  return params;
};
